import { AxiosError } from 'axios'

export function getHttpStatus(error: unknown): number | null {
  if (error instanceof AxiosError) {
    return error.response?.status ?? null
  }

  return null
}

export function isEndpointUnavailable(error: unknown): boolean {
  const status = getHttpStatus(error)
  return status === 404 || status === 405
}

export function isForbidden(error: unknown): boolean {
  const status = getHttpStatus(error)
  return status === 401 || status === 403
}

/** Сигнал вкладке: проект ушёл в сборку — об этом сказал 423 одному из его подресурсов. */
export const PROJECT_NOT_READY_EVENT = 'ai-stone:project-not-ready'

/**
 * ID проекта из адреса его подресурса (/projects/{id}/conversations и подобных).
 * Сам /projects/{id} сюда намеренно не попадает: перепрашивать проект в ответ
 * на его же 423 — замкнутый круг.
 */
export function projectIdFromSubresourceUrl(url: string | undefined): string | null {
  return url?.match(/(?:^|\/)projects\/([^/?#]+)\/[^?#]/)?.[1] ?? null
}

/**
 * 423 отдаёт проект, который ещё собирается: кабинету нужен не текст ошибки,
 * а состояние сборки и причина остановки, чтобы нарисовать заглушку.
 */
export function getProjectNotReady(
  error: unknown,
): { status: 'provisioning' | 'blocked'; blockReason: string | null } | null {
  if (!(error instanceof AxiosError) || error.response?.status !== 423) {
    return null
  }

  const data = error.response.data as { status?: unknown; block_reason?: unknown } | undefined
  const status = data?.status === 'blocked' ? 'blocked' : 'provisioning'
  const blockReason = typeof data?.block_reason === 'string' ? data.block_reason : null

  return { status, blockReason }
}

export function getServerMessage(error: unknown): string | null {
  if (error instanceof AxiosError) {
    const data = error.response?.data
    if (data && typeof data === 'object' && 'message' in data) {
      const message = (data as { message?: unknown }).message
      if (typeof message === 'string' && message.trim() !== '') {
        return message
      }
    }
  }

  return null
}
